const text = document.querySelector("#productText");
const btn = document.querySelector("#copyBtn");
const copy = document.querySelector(".product-number__copy");

btn.addEventListener("click", () => {
  navigator.clipboard.writeText(text.innerHTML).then(() => {
    copy.style.opacity = "1";
    copy.style.transform = "translateY(-2px)";

    setTimeout(() => {
      copy.style.opacity = "0";
      copy.style.transform = "translateY(5px)";
    }, "3000");
  });
});
